import PreloadIframe from '../../../../../pages/vip/features/preload-iframe/preload-iframe';

export default PreloadIframe;
